<svg class="icon">
  <use class="fix-ie" [attr.href]="path + '/icons.svg#' + name"></use>
</svg>
